import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import el from "./translations/el.json";
import en from "./translations/en.json";

export const LANGUAGE_STORAGE_KEY = "election-atlas-language";
export const DEFAULT_LANGUAGE = "el";
export const LANGUAGES = {
  el: "el",
  en: "en",
};

export const normalizeLanguage = (language) =>
  language === LANGUAGES.en ? LANGUAGES.en : DEFAULT_LANGUAGE;

export const getStoredLanguage = () => {
  if (typeof window === "undefined") {
    return DEFAULT_LANGUAGE;
  }

  return normalizeLanguage(window.localStorage.getItem(LANGUAGE_STORAGE_KEY));
};

export const storeLanguage = (language) => {
  if (typeof window === "undefined") {
    return;
  }

  window.localStorage.setItem(LANGUAGE_STORAGE_KEY, normalizeLanguage(language));
};

const initialLanguage = getStoredLanguage();

i18n.use(initReactI18next).init({
  resources: {
    el: {
      common: el,
    },
    en: {
      common: en,
    },
  },
  lng: initialLanguage,
  fallbackLng: DEFAULT_LANGUAGE,
  defaultNS: "common",
  interpolation: {
    escapeValue: false,
  },
});

if (typeof document !== "undefined") {
  document.documentElement.lang = initialLanguage;
}

export default i18n;
